import { useLayoutEffect, useRef } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Header from "../../landingPage/Header";
import Footer from "../../landingPage/Footer";
import ContactForm from "../../landingPage/ContactForm";
import SliderRating from "../../landingPage/SliderRating";
import { GAEventTrack } from "../../../utils/hooks/GA_events";
import { pageMetadata } from "../../../config/metadata";
import SEO from "../../../Seo";
const RegisterLayout = () => {
  const metadata = pageMetadata.schoolRegistrationSeo;
  document.title = metadata.title;
  document.description = metadata.description;
  const contactFormRef = useRef(null);
  const setFormRef = (ref) => {
    contactFormRef.current = ref;
  };

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const location = useLocation();
  const tabName = location.pathname.startsWith("/register/school") ? "school" : "individual";

  return (
    <>
    <SEO
        title={metadata.title}
        description={metadata.description}
        keywords={metadata.keywords}
        canonical={metadata.canonical}
        ogTitle={metadata.ogTitle}
        ogDescription={metadata.ogDescription}
        ogImage={metadata.ogImage}
        ogUrl={metadata.ogUrl}
        ogType={metadata.ogType}
        twitterCard={metadata.twitterCard}
        twitterTitle={metadata.twitterTitle}
        twitterDescription={metadata.twitterDescription}
      />
    <div>
      <Header placement="register" userType={tabName} />
      <section
        className={`school-registration pt-24 ${
          tabName === "school" ? "lg:pt-8" : "lg:pt-0"
        }`}
      >
        <div className="form-container" style={{ position: "relative" }}>
          <div className="container-fluid px-4 sm:px-6 lg:px-8" style={{ paddingTop: tabName === "individual" ? '90px' : '' }}>
            <div className="row justify-content-center">
              <div className={tabName === "individual" ? "col-12 col-xl-11" : "col-12 col-md-10 col-lg-10 col-xl-8"}>
                <div className="form-data step-1">
                  <div className="mobile-header">
                    {tabName === "school" && (
                      <>
                        <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800 mb-4 mt-6 sm:mt-2 lg:mt-0 pr-0 md:pr-48 lg:pr-56">
                          Register Your School on Practido
                        </h1>
                        <div className="mt-4 space-y-4">
                          <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                            It's free, quick, and takes less than a minute.
                            <br />
                            No hidden fees, only benefits for your school and
                            students.
                          </p>

                          <div className="bg-blue-50 border-l-4 rounded-lg border-blue-400 p-3 sm:p-4 rounded-r-lg mb-4">
                            <h4 className="text-blue-800 font-semibold text-sm sm:text-base mb-3">
                              What Happens After You Register?
                            </h4>
                            <ol className="space-y-2 text-xs sm:text-sm text-gray-700">
                              <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-xs font-semibold mr-2 sm:mr-3 mt-0.5 flex-shrink-0">
                                  1
                                </span>
                                <span>
                                  You'll get your unique student registration
                                  link.
                                </span>
                              </li>
                              <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-xs font-semibold mr-2 sm:mr-3 mt-0.5 flex-shrink-0">
                                  2
                                </span>
                                <span>
                                  Share it with parents and students (WhatsApp,
                                  email, circular).
                                </span>
                              </li>
                              <li className="flex items-start">
                                <span className="bg-blue-500 text-white rounded-full w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center text-xs font-semibold mr-2 sm:mr-3 mt-0.5 flex-shrink-0">
                                  3
                                </span>
                                <p>
                                  Students who use that link get -<br />
                                  <strong className="">
                                    Special Academic Year Offer: One-time fee of
                                    ₹99 + School Fee, per student (valid for
                                    this academic year)
                                  </strong>
                                  on Practido - Olympiad Practice App.
                                </p>
                              </li>
                            </ol>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <OlympiadExams /> */}
      <SliderRating contactFormRef={contactFormRef} />
      <ContactForm contactFormRef={setFormRef} />
      <Footer />
    </div>

    </>
  );
};

export default RegisterLayout;
